<div [ngClass]="showHideClass">
  <mc-doc-source-photo-ng *ngIf="isImage" [currentFeature]="currentFeature" [document]="document"></mc-doc-source-photo-ng>
  <mc-doc-source-video-ng *ngIf="isVideo" [currentFeature]="currentFeature" [document]="document"></mc-doc-source-video-ng>
  <div *ngIf="!isTypeSupported">No Matching Source Component</div>
</div>
